import React from 'react';
import theme from '../../theme';

function Footer() {
  return (
    <footer className={`bg-white border-t border-olive-200`}>
      <div className={`container mx-auto px-4 py-4 text-center ${theme.textSecondary} text-sm`}>
        <p>&copy; {new Date().getFullYear()} Mozart Trader. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;